<template>
    <main class="order order-flight">
        <div class="container">
            <div class="row">
                <div class="col-12">
                    <div class="navsteps navstepts-flight">
                        <div class="navsteps__item">
                            <div class="number">1</div>
                            <div class="descr">Розрахунок</div>
                        </div>
                        <div class="navsteps__item">
                            <div class="number">2</div>
                            <div class="descr">Вибір СК</div>
                        </div>
                        <div class="navsteps__item active">
                            <div class="number">3</div>
                            <div class="descr">Оформлення</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="orders osago">
            <div class="container">
                <div class="row">
                    <div class="col-lg-12">
                        <a href="javascript:void(0);" class="go-back" @click="$router.go(-1)">
                            Повернутися до вибору
                        </a>
                        <div v-if="offerInfo" class="params-search">
                            <a class="params-search__toggler collapsed" data-toggle="collapse"
                               data-target="#searchcollapse" aria-expanded="false" aria-controls="#searchcollapse">
                                <span>Параметри полісу</span>
                                <svg width="11" height="6" viewBox="0 0 11 6" fill="none"
                                     xmlns="http://www.w3.org/2000/svg">
                                    <path
                                        d="M10.2795 2.75059e-08L11 0.69496L5.5 6L-2.31891e-07 0.694961L0.7205 4.45343e-07L5.50275 4.61273L10.2795 2.75059e-08Z"
                                        fill="black"/>
                                </svg>
                            </a>

                            <div class="collapse" id="searchcollapse">
                                <div class="params-search__content">
                                    <div class="info">
                                        <b>{{ offerInfo.publicName }}</b>
                                        <div class="logo">
                                            <img v-if="offerInfo.company.logo" :src="offerInfo.company.logo" alt="logo">
                                            <img v-else src="images/aboutUs-insurance_icon.svg" alt="logo">
                                        </div>
                                    </div>
                                    <div class="params">
                                        <div class="params-item">
                                            <p>Компанія:</p>
                                            <span>{{ offerInfo.companyNamePublic }}</span>
                                        </div>
                                        <div class="params-item">
                                            <p>Транспортний засіб:</p>
                                            <span>{{ searchInfo.carType.name }}</span>
                                        </div>
                                        <div class="params-item">
                                            <p>Покриття:</p>
                                            <span>{{ searchInfo.country.name }}</span>
                                        </div>
                                        <div class="params-item">
                                            <p>Тип користувача:</p>
                                            <span>{{ searchInfo.userType.value }}</span>
                                        </div>
                                        <div class="params-item">
                                            <p>Початок дії:</p>
                                            <span>{{ searchInfo.startDate }}</span>
                                        </div>
                                        <div class="params-item">
                                            <p>Період:</p>
                                            <span>{{ searchInfo.periodOption.name }}</span>
                                        </div>
                                        <div class="params-item">
                                            <p>Вартість:</p>
                                            <span>{{ offerInfo.price }} грн</span>
                                        </div>

                                    </div>



                                    <div class="result__param param-price">
                                      <div class="heading result__price">
                                        <div v-if="offerInfo.dynamicDiscountPrice > 0 || offerInfo.discountPrice > 0 || offerInfo.dynamicDiscountedSum > 0" class="old">
                                          <span>{{ offerInfo.price }} <span>грн</span></span>
                                          <b v-if="offerInfo.dynamicDiscountedSum > 0">-{{ offerInfo.dynamicDiscountedSum }} грн</b>
                                          <b v-else >-{{ offerInfo.discountPercent || Math.round(((offerInfo.price - offerInfo.discountPrice) / offerInfo.price) * 100) }}%</b>
                                          <i
                                              data-placement="bottom"
                                              data-toggle="tooltip"
                                              title=""
                                              class="icon question"
                                              data-original-title="Знижка надається безпосередньо за наш рахунок від ціни, що надається страховою компанією. Ми забезпечуємо найнижчу ціну на ринку. Вартість поліса вказана з урахуванням знижки."></i>

                                        </div>
                                        <b>Загальна вартість</b>
                                        <p v-if="offerInfo.dynamicDiscountPrice > 0 || offerInfo.discountPrice > 0" class="price value red">{{ showDiscountPrice(offerInfo) }} грн </p>
                                        <p v-else class="price">{{ showPrice(offerInfo) }} грн</p>
                                      </div>
                                    </div>


                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-12">
                                <div class="row">
                                    <div class="col-auto">
                                        <div class="fill-btn-element">
                                            <div class="icon">
                                                <button @click="fillClientData()" class="btn" style="width: 53px">
                                                    <div v-if="isfillClientData"
                                                         class="option-loader spinner-border"
                                                         style="height: 22px; width: 22px; margin-right: 12px;"
                                                         role="status">
                                                    </div>
                                                    <svg v-else width="32" height="32" viewBox="0 0 32 32" fill="none"
                                                         xmlns="http://www.w3.org/2000/svg"
                                                         xmlns:xlink="http://www.w3.org/1999/xlink">
                                                        <rect width="32" height="32" fill="url(#pattern3)"/>
                                                        <defs>
                                                            <pattern id="pattern3"
                                                                     patternContentUnits="objectBoundingBox" width="1"
                                                                     height="1">
                                                                <use xlink:href="#image0_561_1706"
                                                                     transform="scale(0.01)"/>
                                                            </pattern>
                                                            <image id="image0_561_1706" width="100" height="100"
                                                                   xlink:href="data:image/png;base64,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"/>
                                                        </defs>
                                                    </svg>
                                                </button>
                                            </div>
                                            <i class="icon question" data-html="true" data-placement="bottom"
                                               data-select="true" data-toggle="tooltip" title="Заповнення форми"></i>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <form class="step-block">
                            <div class="row">
                                <div class="col-12">
                                    <insurer-info-form
                                        v-model="info"
                                        @selectInsuredInfo="selectInsuredInfo"
                                        ref="insurerInfoForm"
                                    />
                                    <div class="row">
                                        <div class="col-lg-12">
                                            <DocumentsBlock
                                                ref="documentBlock"
                                                :productType="3"
                                                :offerInfo="offerInfo"
                                                :searchInfo="searchInfo"
                                                :documentation="info.documentation"
                                                :submitCheck="submitCheck"
                                                :dateBirth="info.dateBirth"
                                                @data-chenged="getClientDataForUpdating"
                                            ></DocumentsBlock>
                                        </div>

                                        <div class="col-12">
                                            <car-info-form
                                              ref="carInfo"
                                              v-model="car"
                                              :offer-info="offerInfo"
                                              :disabled="disableCarData"
                                            />
                                        </div>
                                        <div class="col-lg-6">
                                            <div class="form-group">
                                                <label>Мiсце реєстрації власника ТЗ згідно техпаспорту</label>
                                                <citySearch
                                                    :citySelect='citySelect'
                                                    v-bind:cityStore="this.cityStore"
                                                    :disabled="isArx() && !!car.city"
                                                />
                                                <small class="error" v-if="submitCheck && !car.city">
                                                    Вкажіть місце реєстрації власника ТЗ
                                                </small>
                                            </div>
                                        </div>
                                        <div class="row col-lg-12 order-nav">
                                            <div class="col-lg-12 text-center">
                                                <button type="button" class="btn btn-blue"
                                                        @click="submitHandler('next')">
                                                    Перейти до наступного кроку
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
        <animationModal></animationModal>
        <modalSuccess @dataDraftUrl="getDraftUrl()" @next="nextStep()"></modalSuccess>
        <clients-fill-data-func :show-fill-client-data-modal="showFillClientDataModal" :clien-data="selectedPibInn"
                                :search-info="searchInfo" :offer-info="offerInfo" :product-type="productType"
                                @close="showFillClientDataModal = false" @save="saveFillData"/>
    </main>
</template>


<script>

//TODO добавить возможность отбращения по абсолютному пути
import Multiselect from 'vue-multiselect';
import VueTypeaheadBootstrap from 'vue-typeahead-bootstrap';
import { companyMixin, customerMixin, documentMixin } from '../../mixin';
import { getData, saveClient } from '@/api/client';
import { orderGreenCard } from '@/api/orderGreenCard';
import ClientsFillDataFunc from '@/components/app/clients/clientsFillDataFunc.vue';
import citySearch from '@/components/app/forms/CitySearch.vue';
import DocumentsBlock from '@/components/app/forms/DocumentsBlock.vue';
import modalSuccess from '@/components/app/modals/modal-draft-success';
import animationModal from '@/components/app/modals/modal-draftAnimation';
import CarInfoForm from '@/views/greencard/components/CarInfoForm.vue';
import InsurerInfoForm from '@/views/greencard/components/InsurerInfoForm.vue';
import { InsuredsListItem } from '@/views/osago/components';

export default {
  mixins: [customerMixin, companyMixin, documentMixin],
  components: {
    InsurerInfoForm,
    CarInfoForm,
    ClientsFillDataFunc,
    Multiselect,
    citySearch,
    animationModal,
    VueTypeaheadBootstrap,
    modalSuccess,
    InsuredsListItem,
    DocumentsBlock,
  },
  data: function () {
    return {
      utskModuleId: null,
      tasModuleId: null,
      fetchClientsTimeout: null,
      selectedPibInn: false,
      isfillClientData: false,
      showFillClientDataModal: false,
      isfillData: false,
      clientId: null,
      productType: 'greenCard',
      brandObj: null,
      modelObj: null,
      disable_document_driver_license: false, // Временный фикс для ИНГО, доступен только паспорт
      isLoadInsuredsList: false,
      isLoadInsuredsListBySurname: false,
      isLoadInsuredsByErdpyCode: false,
      isLoadInsuredsByCompanyName: false,
      draftUrl: '',
      errors: [],
      offerInfo: null,
      orderId: null,
      searchInfo: null,
      submitCheck: false,
      disableCarData: false,
      carBrands: [],
      carModels: [],
      name_ua: null,
      surname_ua: null,
      patronymic_ua: null,
      insuredsList: [],
      insuredsListBySurname: [],
      insuredsListByErdpyCode: [],
      insuredsListByCompanyName: [],
      enableCarWatcher: true,
      info: {
        documentType: 2,
        identificationCode: null,
        erdpyCode: null,
        withoutIdentificationCode: false,
        withoutDocuments: false,
        name: null,
        surname: null,
        name_ua: null,
        surname_ua: null,
        patronymic_ua: null,
        dateBirth: null,
        phone: null,
        mail: null,
        region: null,
        city: null,
        street: null,
        house: null,
        apartment: null,
        internationalPassport: null,
        passportSerial: null,
        passportNumber: null,
        passportCompany: null,
        passportDate: null,
        documentation: {
          //TODO текущее значение нобходимо будет брать с словаря(api)
          type: 2,
          serial: null,
          number: null,
          issuedBy: null,
          dateOfIssue: null,
          endDateOfIssue: null,
          dateOfIssueError: false,
        },
      },
      car: {
        vin: null,
        year: null,
        brand: null,
        autoCategory: null,
        model: null,
        number: null,
        city: null,
        withoutVin: false
      }
    };
  },
  //TODO ????
  async created() {
    this.isfillData = true;
    this.offerInfo = this.$store.getters.GREENCARD_INFO_OFFER;
    this.searchInfo = this.$store.getters.GREENCARD_SEARCH_PARAMS;

    await this.getModuleId([{ 'utsk': 'utskModuleId' }, { 'tas': 'tasModuleId' }]);

    this.fetchInfo(this.$store.getters.GREENCARD_INFO_USER);

    if (this.$store.getters.GET_CLIENT) {
      this.clientId = this.$store.getters.GET_CLIENT;
    }

    if (this.$store.getters.GREENCARD_FULL_ORDER) {
      this.orderId = this.$store.getters.GREENCARD_FULL_ORDER.orderId;
    }
    if (this.carInfo) {
      this.disableCarWatch();
      //TODO need refactoring ((
      // Зберігаємо місто реєстрації, яке вже виставив CitySearch (дефолт/значення),
      // бо carInfo зі сторінки розрахунку може не містити city і затирає його
      const preservedCity = this.car.city;
      this.car = this.carInfo;
      if (!this.car.city && preservedCity) {
        this.car.city = preservedCity;
      }
      if (this.car.additionalParameters) {
        this.car.engineSize = this.car.additionalParameters.capacity;
        this.car.nSeating = this.car.additionalParameters.numberOfSeats;
        this.car.ownWeight = this.car.additionalParameters.ownWeight;
        this.car.totalWeight = this.car.additionalParameters.totalWeight;
      }

      let foundBrand = null;
      let foundModel = null;
      if ((!this.carInfo.brand || this.carInfo.brand === null || this.carInfo.brand.length === 0) || (!this.carInfo.model || this.carInfo.model === null || this.carInfo.model.length === 0)) {
        this.identifyModel();
      } else if (this.carInfo.brand && this.carInfo.brand.length > 0 && this.carInfo.model && this.carInfo.model.length > 0) {
        foundBrand = this.carBrands.find((e) => {
          return e.name.toLowerCase() == this.carInfo.brand.toLowerCase();
        });
        if (!foundBrand) {
          this.addNewCar(this.carInfo.brand, 'brand');
        } else {
          this.brandObj = foundBrand;
        }
        let tmp_car = JSON.parse(JSON.stringify(this.car));
        setTimeout(() => {
          foundModel = this.carModels.find((e) => {
            return e.name.toLowerCase() == tmp_car?.model?.toLowerCase();
          });
          if (!foundModel) {
            this.addNewCar(tmp_car.model, 'model');
          } else {
            this.modelObj = foundModel;
          }
          this.enableCarWatch();
        }, 300);
      }
    }

    if (!this.car.number && this.searchInfo?.car?.number) {
      this.car.number = this.searchInfo.car.number;
    }

    // Фіксуємо дані авто, отримані на етапі розрахунку, і забороняємо їх редагування
    if (!this.carInfo && this.searchInfo?.car) {
      this.prefillCarFromSearch(this.searchInfo.car);
    }

    // Блокуємо форму авто, коли з розрахунку прийшли розпізнані марка й модель.
    // Виняток — редагування вже створеної чернетки з історії (є orderId):
    // копіювання та пролонгація створюють нове замовлення, тому дані авто фіксуються.
    const isHistoryDraftEdit = this.$route.query?.from === 'history' && !!this.orderId;
    if (!isHistoryDraftEdit) {
      this.disableCarData = !!(this.car.brand && this.car.model);
    }

    if (this.offerInfo.company.external_id == 38) {
      this.disable_document_driver_license = true;
      this.info.documentType = 2;
    }
    this.isfillData = false;
  },
  //TODO ????
  mounted() {
    $('[data-toggle="tooltip"]').tooltip({
      html: true
    });

    if (this.$store.state.carsStore.marks === null || this.$store.state.carsStore.marks === undefined) {
      return false;
    } else {
      this.carBrands = this.$store.state.carsStore.marks;
    }
  },
  updated() {
    $('[data-toggle="tooltip"]').tooltip({
      html: true
    });
  },

  computed: {
    cityStore() {
      return this.car.city;
    },
    carInfo() {
      return this.$store.getters.GREENCARD_INFO_CAR;
    },
  },
  watch: {
    'car.number': function(newValue, oldVAlue){
      this.car.number = newValue.toUpperCase();
    },
  },
  methods: {
    updateStore(offerInfo){
      this.$store.commit('SET_GREENCARD_INFO_OFFER', offerInfo);
      this.$store.commit('SET_GREENCARD_FULL_ORDER', offerInfo.orderId);
    },
    showPrice(offer){
      return Number(offer.price) ;
    },
    showDiscountPrice(offer){
      return (offer.prolongOrderId) ? offer.price: Number(offer.dynamicDiscountPrice || offer.discountPrice || (offer.price - (offer.dynamicDiscountedSum || 0)));
    },
    async getModuleId(data) {
      try {
        const response = await axios.post('/api/get-module-id', { data: data });
        if (response.data) {
          for (let key in response.data) {
            if (response.data.hasOwnProperty(key)) {
              this[response.data[key].variable] = response.data[key].module_id;
            }
          }
        }
      } catch (error) {
        console.error('Failed to fetch module ID:', error);
      }
    },
    async fetchClients(query, type) {
      if (!query) {
        this.isLoadInsuredsList = false;
        return;
      }
      this.insuredsList = [];
      let params = {
        'requestType': 'clientsByUserId',
        'searchText': query,
        'customerType': this.searchInfo.userType.id
      };
      clearTimeout(this.fetchClientsTimeout);
      this.fetchClientsTimeout = setTimeout(async () => {
        let response = await getData(params);
        if (type == 'identificationCode') {
          this.insuredsList = response.data.data.items;
        } else if (type == 'erdpyCode') {
          this.insuredsListByErdpyCode = response.data.data.items;
        } else if (type == 'surname') {
          this.insuredsListBySurname = response.data.data.items;
        } else if (type == 'name') {
          this.insuredsListByCompanyName = response.data.data.items;
        }
        this.isLoadInsuredsList = false;
        this.isLoadInsuredsByErdpyCode = false;
        this.isLoadInsuredsByCompanyName = false;
        this.isLoadInsuredsListBySurname = false;
      }, 1000);
    },
    addNewCar(newEl, type) {
      if (typeof newEl === 'string') {
        // Если newEl является строкой, создаем новый объект
        const newCar = { id: Date.now(), name: newEl };
        if (type === 'model') {
          this.carModels.push(newCar);
          this.modelObj = newCar;
        } else if (type === 'brand') {
          this.carBrands.push(newCar);
          this.brandObj = newCar;
        }
      } else {
        if (type === 'model') {
          this.modelObj = newEl;
        } else if (type === 'brand') {
          this.brandObj = newEl;
        }
      }
    },
    disableCarWatch() {
      if (this.$route.query?.from === 'history') {
        this.enableCarWatcher = false;
      }
    },
    enableCarWatch() {
      this.$nextTick(() => {
        this.enableCarWatcher = true;
      });
    },
    formatDate(date) {
      if (date.match(/^\d{2}\.\d{2}\.\d{4}$/)) {
        // Заменяем точки на дефисы
        date = date.replace(/\./g, '-');
      }
      return date;
    },
    submitHandler(type) {
      this.submitCheck = true;

      if (this.$refs.insurerInfoForm.$v.$invalid) {
        this.$refs.insurerInfoForm.$v.$touch();
        this.$refs.insurerInfoForm.$el.scrollIntoView({ block: 'center', behavior: 'smooth' });
        return;
      }

      if (this.$refs.carInfo.$v.$invalid) {
        this.$refs.carInfo.$v.$touch();
        this.$refs.carInfo.$el.scrollIntoView({ behavior: 'smooth' });
        return;
      }

      if (this.$refs.documentBlock.$v.$invalid) {
        this.$refs.documentBlock.$v.$touch();
        this.$refs.documentBlock.$el.scrollIntoView({ behavior: 'smooth' });
        return;
      }

      this.searchInfo.startDate = this.formatDate(this.searchInfo.startDate);
      this.getClientDataForUpdating();
      this.offerInfo.allowed_documents = this.offerInfo.available_documents ?? this.offerInfo.allowed_documents ?? null;

      let offerInfo = Object.assign({}, this.offerInfo);

      let discountDetails = {
        dynamicDiscountPrice: 0,
        dynamicDiscountPercent: 0,
        dynamicDiscountedSum: 0,
        dynamicEarnings: 0
      };
      if(this.offerInfo.dynamicDiscountPrice > 0) {
        discountDetails.dynamicDiscountPrice = +parseFloat(offerInfo.dynamicDiscountPrice).toFixed(2);
        discountDetails.dynamicDiscountPercent = +parseFloat(offerInfo.dynamicDiscountPercent).toFixed(2);
        discountDetails.dynamicDiscountedSum = +parseFloat(offerInfo.dynamicDiscountedSum).toFixed(2);
        discountDetails.dynamicEarnings = +parseFloat(offerInfo.dynamicEarnings).toFixed(2);
        discountDetails.earnings = +parseFloat(offerInfo.earnings).toFixed(2);

        offerInfo.discountDetails = discountDetails;
        offerInfo = { ...offerInfo, ...discountDetails };

      }else{
        offerInfo.discountDetails = null;
        offerInfo = { ...offerInfo, ...discountDetails };
      }

      this.updateStore(offerInfo);


      let searchInfo = this.searchInfo;

      let userInfo = Object.assign({}, this.info);

      if(this.searchInfo.userType.id == 2){
        userInfo = this.formatNames(userInfo);
      }

      let carInfo = this.car;

      let params = {
        type: type,
        statusId: 1, //на этом этапе у нас только черновик возможен
      };

      if (['save','next'].includes(type)) {
        this.showAnimateModal();
      }

      this.$store.commit('SET_GREENCARD_INFO_USER', userInfo);
      this.$store.commit('SET_GREENCARD_INFO_CAR', carInfo);

      orderGreenCard(offerInfo, searchInfo, userInfo, carInfo, this.orderId, params).then((response) => {
        this.orderId = response?.data?.data[0]?.id;
        $('#modalPayAnimation').modal('hide');
        offerInfo = Object.assign({}, this.offerInfo);
        offerInfo.orderId =  this.orderId;
        this.updateStore(offerInfo);

        let dateText = 'Дата народження';
        if(this.searchInfo.userType.id == 2){
          dateText = 'Дата створення';
        }

        if(response?.data?.data[0]?.status == 'sanctioned'){
          this.$alert(
            `<div class="sanctions-alert-content">
                               <p>Данного клієнта знайдено у санкційних списках, заборонено оформлення полісу. Зверніться у підтримку якщо сталась помилка</p>
                               <p><strong>Ім'я:</strong> ${response?.data?.data[0]?.message?.name || response?.data?.data[0]?.message[0]?.name || 'Немає даних'}</p>
                               <p><strong>${dateText}:</strong> ${response?.data?.data[0]?.message?.birthdate || response?.data?.data[0]?.message[0]?.birthdate || 'Немає даних'}</p>
                               <p><strong>Документи:</strong> ${response?.data?.data[0]?.message?.identity_docs || response?.data?.data[0]?.message[0]?.identity_docs || 'Немає даних'}</p>
                               <p><strong>Санкції:</strong> ${response?.data?.data[0]?.message?.sanctions || response?.data?.data[0]?.message[0]?.sanctions || 'Немає даних'}</p>
                             </div>`,
            'Санкції!',
            {
              dangerouslyUseHTMLString: true,
              type: 'error',
              customClass: 'sanctions-alert'
            }
          );
          return false;
        }
        if(response?.data?.data[0]?.status ==  'possible_match'){
          this.$alert(
            `<div class="sanctions-alert-content">
                               <p>Данного клієнта вірогідно знайдено у санкційних списках, заборонено оформлення полісу. Зверніться у підтримку якщо сталась помилка</p>
                               <p><strong>Ім'я:</strong> ${response?.data?.data[0]?.message?.name || response?.data?.data[0]?.message[0]?.name || 'Немає даних'}</p>
                               <p><strong>${dateText}:</strong> ${response?.data?.data[0]?.message?.birthdate || response?.data?.data[0]?.message[0]?.birthdate || 'Немає даних'}</p>
                               <p><strong>Документи:</strong> ${response?.data?.data[0]?.message?.identity_docs || response?.data?.data[0]?.message[0]?.identity_docs || 'Немає даних'}</p>
                               <p><strong>Санкції:</strong> ${response?.data?.data[0]?.message?.sanctions || response?.data?.data[0]?.message[0]?.sanctions || 'Немає даних'}</p>
                             </div>`,
            'Санкції!',
            {
              dangerouslyUseHTMLString: true,
              type: 'error',
              customClass: 'sanctions-alert'
            }
          );
          return false;
        }

        if (type == 'save') {
          $('#modalPayAnimation').modal('hide');
          this.draftUrl = response.data?.data[1]?.contractDraft_path;
          $('#modalFlightSuccess').modal('show');
          return;
        }

        if (type === 'next') {
          this.$router.push({ name: 'greenCardFinnaly' });
        } else {
          $('#modalPayAnimation').modal('hide');
          this.$alert('Чернетка успішно збережена.');
        }
      }).catch((error) => {
        console.error(error);
        $('#modalPayAnimation').modal('hide');
        if (error?.response?.data?.data?.orderId[0].includes('недостатньо коштів')) {
          this.$alert(error?.response?.data?.data?.orderId[0], '', 'error');
        } else {
          this.$alert('Щось пішло не так. Перевірте заповнені поля.');
        }
      });
    },
    formatNames(userInfo) {
      // Проверка и форматирование name_ua
      if (userInfo.name_ua && /ТОВ/i.test(userInfo.name_ua)) {
        userInfo.name_ua = userInfo.name_ua.replace(/ТОВ/i, '').trim() + ' ТОВ';
      }

      // Проверка и форматирование name
      if (userInfo.name && /LLC/i.test(userInfo.name)) {
        userInfo.name = userInfo.name.replace(/LLC/i, '').trim() + ' LLC';
      }
      return userInfo;
    },
    getDraftUrl() {
      window.open(`/api/orders/draft/${this.$store.getters.USER.id}/${this.orderId}`);
    },
    nextStep() {
      $('#modalFlightSuccess').modal('hide');
      $('#modalPayAnimation').modal('hide');
      this.$router.push({ name: 'greenCardFinnaly' });
    },
    showAnimateModal() {
      $('#modalPayAnimation').modal({
        backdrop: 'static',
        keyboard: true,
        show: true,
      });

      let i = 0;

      if (i == 0) {
        i = 1;
        let width = 1;
        let id = setInterval(frame, 200);

        /**
         *
         */
        function frame() {
          if (width >= 99) {
            clearInterval(id);
            i = 0;
          } else {
            width += 2;
            $('.results_anime_percent-text').text(`${width}%`);
            $('.results_anime_line-scale').css({ width: `${width}%` });
          }
        }
      }
    },
    identifyModel() {
      if (this.car.number && this.car.number.length) {
        axios({ url: '/api/directories/car/' + this.car.number.trim().toUpperCase(), method: 'GET' }).then(({ data }) => {
          let result = data.data;
          let foundBrand = null;
          let foundModel = null;
          if (result) {
            this.car.brand = result.mark;

            foundBrand = this.carBrands.find((e) => {
              return e.name.toLowerCase() == result.mark.toLowerCase();
            });
            if (!foundBrand) {
              this.addNewCar(result.mark, 'brand');
            } else {
              this.brandObj = foundBrand;
            }
            setTimeout(() => {
              this.car.model = result.model;
              foundModel = this.carModels.find((e) => {
                return e.name.toLowerCase() == result.model.toLowerCase();
              });
              if (!foundModel) {
                this.addNewCar(result.model, 'model');
              } else {
                this.modelObj = foundModel;
              }
            }, 300);
            this.car.year = result.year;
            this.car.vin = result.vin;
            this.car.autoCategory = result.autoCategory;

            if (this.car.vin) {
              this.car.withoutVin = false;
            } else {
              this.car.withoutVin = true;
            }

          } else {
            //TODO сделать через цикл
            this.car.brand = null;
            this.brandObj = null;
            this.car.model = null;
            this.modelObj = null;
            this.car.year = null;
            this.car.vin = null;
            this.car.autoCategory = null;
          }
        }).catch(err => (console.log(err)));
      }
    },
    //TODO need refactoring....
    fetchInfo(data) {
      if (data) {
        if (this.searchInfo.userType.id == 2) {
          //new
          data.documentation.type = null;
          data.documentation.serial = null;
          data.documentation.number = null;
          data.documentation.issuedBy = null;
          data.documentation.dateOfIssue = null;
          data.documentation.endDateOfIssue = null;
          //

          data.passportSerial = null;
          data.passportNumber = null;
          data.passportDate = null;
          data.documentType = null;
          data.passportCompany = null;

          data.surname = null;
          data.surname_ua = null;
          data.patronymic_ua = null;
          data.identificationCode = null;

          if (!data.contact) {
            data.contact = {
              fullName: null,
              position: null,
              documentType: null,
              documentNumber: null,
              documentDate: null,
            };
          }
          data.isDP = false;
        } else {
          data.erdpyCode = null;

          if (!data?.documentation) {
            data.documentation = {};
          }

          data.documentation.type = data?.documentation?.type ? this.convertDocumentToNumber(data?.documentation?.type) : data.documentType;

          data.documentation.serial = data.documentation.serial ?? data?.passportSerial ?? null;
          data.documentation.number = data.documentation.number ?? data?.passportNumber ?? null;
          data.documentation.issuedBy = data.documentation.issuedBy ?? data?.passportCompany ?? null;
          data.documentation.dateOfIssue = data.documentation.dateOfIssue ?? data?.passportDate ?? null;
          data.documentation.endDateOfIssue = data.documentation.endDateOfIssue ?? data?.endDateOfIssue ?? null;

          data.isFop = false;
        }

        this.info = data;
        if (this.offerInfo.moduleId == this.utskModuleId) {
          this.name_ua = data?.name_ua || '';
          this.surname_ua = data?.surname_ua || '';
          this.patronymic_ua = data?.patronymic_ua || '';
        }

        if (this.disable_document_driver_license) {
          this.info.documentType = 2;
          this.info.documentation.type = 2;
        }
      }
    },
    citySelect(data) {
      this.car.city = data.city;
    },
    prefillCarFromSearch(searchCar) {
      const additional = searchCar.additional_parameters || {};

      this.car = {
        ...this.car,
        number: searchCar.number ?? this.car.number,
        brand: searchCar.brand ?? null,
        model: searchCar.model ?? null,
        year: searchCar.year ?? null,
        vin: searchCar.vin ?? null,
        autoCategory: searchCar.autoCategory ?? null,
        withoutVin: !searchCar.vin,
        city: searchCar.city ?? this.car.city,
        engineSize: additional.capacity ?? null,
        kvt: additional.kvt ?? null,
        nSeating: additional.numberOfSeats ?? null,
        ownWeight: additional.ownWeight ?? null,
        totalWeight: additional.totalWeight ?? null,
      };
    },
    fetchModels() {
      if (this.car.brand) {
        let brandId = this.$store.state.carsStore.marks.find(mark => mark.name.toLowerCase() === this.car.brand.toLowerCase())?.id;
        let models = this.$store.state.carsStore.models;
        const currentModels = models.filter(function (e) {
          return e.car_mark_id == brandId;
        });
        this.carModels = currentModels;
        this.car.model = currentModels[0]?.name;
      }
    },
    errorTaxNumber: function () {

      if (this.searchInfo.userType.id == 2) {
        return false;
      }

      if (this.info.identificationCode == '' || this.info.identificationCode == null) {
        return false;
      }

      if (this.info.dateBirth == '' || this.info.dateBirth == null) {
        return false;
      }

      if (this.info.dateBirth.length == 10 && this.info.identificationCode.length == 10 && !this.validateTaxNumber(this.info.identificationCode, this.info.dateBirth)) {
        this.errors['personal.identificationCode'] = ['ІПН та Дата народження не співпадають'];

        return true;
      }

      return false;
    },
    validateTaxNumber(tax_number, date) {
      let tax_numberDate = moment('01.01.1900', 'DD.MM.YYYY').add(tax_number.substr(0, 5) - 1, 'day');
      let birthDate = moment(date, 'DD.MM.YYYY');

      return tax_numberDate.isSame(birthDate, 'year')
                && tax_numberDate.isSame(birthDate, 'month')
                && tax_numberDate.isSame(birthDate, 'day');
    },
    errorBirthDate: function () {
      if (this.info.dateBirth == '' || this.info.dateBirth == null || this.info.dateBirth == '') {
        return false;
      }

      if ((parseInt(moment(this.info.dateBirth, 'DD.MM.YYYY').diff(moment(), 'years')) * -1) < 18) {
        this.errors['personal.dateBirth'] = ['Страхувальнику повинно бути більше 18 років'];
        return true;
      } else if ((parseInt(moment(this.info.dateBirth, 'DD.MM.YYYY').diff(moment(), 'years') - 1) * -1) > 100) {
        this.errors['personal.dateBirth'] = ['Страхувальнику повинно бути не більше 100 років'];
        return true;
      }

      return false;
    },
    hasError(name) {
      return this.errors[name] !== undefined;
    },

    getError(name) {
      if (this.hasError(name)) {
        return this.errors[name][0].replace(name, '');
      }

      return '';
    },
    selectInsuredInfo(insured) {
      this.isfillData = true;
      this.selectedPibInn = insured;
      this.clientId = insured.id;

      let selectDocument = false;
      let selectVehicle = false;
      insured.documents = this.getAllowedDocumentsTypes(insured.documents);
      if (insured.documents.length == 1) {
        selectDocument = insured.documents[0];
      }

      if (insured.vehicles.length == 1) {
        selectVehicle = insured.vehicles[0];
      }

      let params = {
        'selectPibInn': insured,
        'selectVehicle': selectVehicle,
        'selectDocument': selectDocument,
        'selectTourists': false,//insured.selectTourists,
      };

      if (!selectVehicle || (this.searchInfo.userType.id !== 2 && !selectDocument)) {
        this.fillClientData();
        this.isfillData = false;
        return;
      }
      this.$store.commit('SET_CLIENT', insured.id);
      this.saveFillData(params);
      this.isfillData = false;
    },
    fillClientData() {
      this.showFillClientDataModal = true;
    },
    saveFillData(params) {
      this.showFillClientDataModal = false;
      this.fillFormFromClientData(params.selectPibInn, params.selectVehicle, params.selectDocument);
    },
    fillFormFromClientData(selectPibInn, selectVehicle, selectDocument) {
      this.isfillData = true;
      this.enableCarWatcher = false;
      this.clientId = selectPibInn.id;
      this.$store.commit('SET_CLIENT', selectPibInn.id);
      let fio_en = selectPibInn.fio_en.split(' ');
      let fio = selectPibInn.fio.split(' ');

      this.info.phone = selectPibInn.phone;
      this.info.mail = selectPibInn.email;


      if (this.searchInfo.userType.id == 2) {
        this.info.name = selectPibInn.fio_en;
        this.info.name_ua = selectPibInn.fio;
        this.info.surname = '';
        this.surname_ua = '';
        this.patronymic_ua = '';
        this.info.identificationCode = null;
        this.info.erdpyCode = selectPibInn.identification_number;
        this.info.dateBirth = null;
        this.info.documentation = {
          type: 2,
          serial: null,
          number: null,
          issuedBy: null,
          dateOfIssue: null,
          endDateOfIssue: null,
          dateOfIssueError: false,
        };
        this.info.contact = {
          fullName: null,
          position: null,
          documentType: null,
          documentNumber: null,
          documentDate: null,
        };
        this.isDP = false;

        if (selectPibInn.contact) {
          this.info.contact = selectPibInn.contact;
        }
      } else {
        this.isFOP = false;
        this.info.name = fio_en[1];
        this.name_ua = fio[1];
        this.info.name_ua = fio[1];
        this.info.surname = fio_en[0];
        this.surname_ua = fio[0];
        this.patronymic_ua = fio[2] ?? '';
        this.info.surname_ua = fio[0];
        this.info.patronymic_ua = fio[2] ?? '';
        this.info.dateBirth = (selectPibInn.date_of_birth) ? moment(selectPibInn.date_of_birth, 'DD-MM-YYYY').format('DD.MM.YYYY') : null;
        this.info.erdpyCode = null;
        this.info.identificationCode = selectPibInn.identification_number;
        if (selectDocument) {
          this.info.documentation.type = selectDocument.document_type;
          this.info.documentation.serial = selectDocument.serial;
          this.info.documentation.number = selectDocument.number;
          this.info.documentation.issuedBy = selectDocument.issued_by;
          this.info.documentation.dateOfIssue = (selectDocument.date_of_issue) ? moment(selectDocument.date_of_issue, 'YYYY-MM-DD').format('DD.MM.YYYY') : null;
          this.info.documentation.endDateOfIssue = (selectDocument.end_date_of_issue) ? moment(selectDocument.end_date_of_issue, 'YYYY-MM-DD').format('DD.MM.YYYY') : null;

          if (![4, 2, 11].some(data => data === selectDocument.document_type)) {
            this.info.passportSerial = '';
            this.info.internationalPassport = '';
            this.info.passportNumber = '';
            this.info.passportCompany = '';
            this.info.passportDate = '';
          }
        } else {
          this.info.documentation = {
            type: 2,
            serial: null,
            number: null,
            issuedBy: null,
            dateOfIssue: null,
            endDateOfIssue: null,
            dateOfIssueError: false,
          };
        }
      }

      this.info.street = selectPibInn.street_en;
      this.info.house = selectPibInn.house;
      this.info.region = selectPibInn.region_en;
      this.info.city = selectPibInn.city_en;
      this.info.apartment = selectPibInn.flat;

      this.info.withoutIdentificationCode = false;

      if(selectVehicle && !this.disableCarData){
        this.car.number = selectVehicle.registration_number.toUpperCase();
        this.car.brand = selectVehicle.mark_name;

        if (selectVehicle.mark_name) {
          let foundBrand = this.carBrands.find((e) => {
            return e.name.toLowerCase() == selectVehicle.mark_name.toLowerCase();
          });
          if (!foundBrand) {
            this.addNewCar(selectVehicle.mark_name, 'brand');
          } else {
            this.brandObj = foundBrand;
          }
        }
        if (selectVehicle.model_name) {
          setTimeout(() => {
            this.car.model = selectVehicle.model_name;
            let foundModel = this.carModels.find((e) => {
              return e.name.toLowerCase() == selectVehicle.model_name.toLowerCase();
            });
            if (!foundModel) {
              this.addNewCar(selectVehicle.model_name, 'model');
            } else {
              this.modelObj = foundModel;
            }
          }, 500);
        }

        this.car.year = selectVehicle.year;
        this.car.vin = selectVehicle.vin;
        this.car.autoCategory = selectVehicle.type;
        if (selectVehicle.registration_place) {
          this.citySelect({ city: selectVehicle.registration_place });
        }

        if (selectVehicle.additional_parameters) {
          this.car.engineSize = selectVehicle.additional_parameters.capacity ?? null;
          this.car.ownWeight = selectVehicle.additional_parameters.ownWeight ?? null;
          this.car.totalWeight = selectVehicle.additional_parameters.totalWeight ?? null;
          this.car.nSeating = selectVehicle.additional_parameters.numberOfSeats ?? null;
        }

        if (this.car.vin) {
          this.car.withoutVin = false;
        } else {
          this.car.withoutVin = true;
        }
      }

      this.insuredsList = [];
      this.insuredsListByErdpyCode = [];

      this.$nextTick(() => {
        this.enableCarWatcher = true;
        this.isfillData = false;
      });
    },
    getOrderData() {
      this.searchInfo.startDate = this.formatDate(this.searchInfo.startDate);
      this.offerInfo.allowed_documents = this.offerInfo.available_documents ?? this.offerInfo.allowed_documents ?? null;
      let info = JSON.parse(JSON.stringify(this.info));

      info.phone = (info.phone == '+38 (0') ? '' : info.phone;

      return {
        'searchInfo': this.searchInfo,
        'offerInfo': this.offerInfo,
        'info': info,
        'carInfo': this.car,
        'orderId': this.orderId,
        'clientId': this.clientId,
        'productType': this.productType
      };
    },
    getClientDataForUpdating() {
      if (this.isfillData == false) {
        const orderData = this.getOrderData();
        this.updateClientData(orderData);
      }
    },
    updateClientData(orderData) {
      if (this.isfillData) return;
      if (
        (this.info.identificationCode && this.info.identificationCode.length === 10) || (this.info.erdpyCode && this.info.erdpyCode.length === 8) ||
                (((this.info.phone !== null && this.info.phone !== '+38 (0' && this.info.phone.length === 19) ||
                        (this.info.mail !== null && this.userData.email !== '' && !this.$v.info.mail.$invalid))
                    && this.info.surname !== null && this.info.name !== null)
      ) {
        orderData = (orderData instanceof Event || !orderData) ? this.getOrderData() : orderData;

        if (orderData) {
          saveClient(orderData).then(response => {
            if (response?.data?.status == 'success') {
              this.clientId = response?.data?.data?.id;
              this.$store.commit('SET_CLIENT', this.clientId);

              this.$store.commit('SET_GREENCARD_FULL_ORDER', this.orderId);
            }
          });
        }
      }
    },
    isArx(){
      return [1027].includes(parseInt(this.offerInfo?.ex_id));
    },
  }
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style scoped>
.order-flight .greencard-spiner {
    right: 22px;
}
.sanctions-alert .el-message-box__message {
  max-height: 300px;
  overflow-y: auto;
  padding-right: 10px;
}
.param-price{
  margin-left: auto;
  background: #F6F7FB;
  box-shadow: 0 0 25px rgba(0, 0, 0, 0.04);
  border-radius: 5px;
  padding: 16px 25px 10px;
  width: 216px;
}
</style>
